import { render, staticRenderFns } from "./Kontragent.vue?vue&type=template&id=c58aefd2&scoped=true"
import script from "./Kontragent.vue?vue&type=script&lang=js"
export * from "./Kontragent.vue?vue&type=script&lang=js"
import style0 from "./Kontragent.vue?vue&type=style&index=0&id=c58aefd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c58aefd2",
  null
  
)

export default component.exports